<template>
  <ListingBlock
    v-if="view && view.hasDocs()"
    class="latest-episodes"
    :view="view"
    :docs="view.docs().filteredDocs.slice(0, 3)"
    :cardProps="{ mobileVariant: 'vertical' }"
  />

  <div v-else>
    <EmptyListingBlock
      class="latest-episodes__empty-block"
      :title="view.pageTitle()"
      :useDefaultImage="true"
    >
      <p>
        Episodes from podcasts you follow will appear here. To follow a podcast,
        simply click the "Follow" button on the podcast page!
      </p>
    </EmptyListingBlock>
  </div>
</template>

<script setup lang="ts">
import ListingBlock from '@/app/components/listing/ListingBlock.vue'
import EmptyListingBlock from './EmptyListingBlock.vue'

import type { ListView } from '@/models/docs.list'

defineProps<{
  view: ListView
}>()
</script>
